export const CLIPPED_ANGLE = 14;
export const NO_SCROLL_ID = 'noscroll';
